<button class="mp-btn tw-primary" [ngClass]="additionalButtonClass || ''" [class.tw-small]="small" [class.tw-full-width]="fullWidth" (click)="openContactDialog()" type="button">{{ text }}</button>
